export default __webpack_public_path__ + "locales/ja-JP/ChangePasswordDialog.json?hash=a1dc7d75880188959fa8fc43cab2c33a";